// External libraries
import gql from 'graphql-tag';

export const ADDRESS_METADATA_FRAGMENT = gql`
  fragment AddressMetadata on LocaleAddressMetadata {
    layout {
      maxLength
      minLength
      isRequired
      name
      regex
    }
    strings {
      cityLabel
      line1Label
      line2Label
      optionalLabel
      postcodeLabel
      stateLabel
      stateList {
        displayText
        value
      }
    }
  }
`;
